import { render } from "./UnidadesView.vue?vue&type=template&id=7e56ec22"
import script from "./UnidadesView.vue?vue&type=script&lang=js"
export * from "./UnidadesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__